import React, { useRef, useEffect, useMemo } from "react"
import styled from "styled-components"
import queryString from "query-string"

// import { StoreContext } from "../../store"

export default function Map({
  data,
  disableAutoload = true,
  query = ``,
  language,
  preselectedSiteId,
  quickCategories = false,
  categoryNames = {},
  menu,
  menuSort,
  style,
  zoom,
  styleControl,
  zoomControl,
  measureControl,
  locationControl,
  printControl,
  legendControl,
  legend,
  scrollZoom,
  onLoad,
  onQueryChange,
}) {
  // const store = useContext(StoreContext)
  const mapRef = useRef()

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.dispatchEvent(
        new CustomEvent(`naturkartanSend`, {
          detail: {
            method: `setQuery`,
            data: query,
          },
        })
      )
    }
  }, [query])

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.addEventListener(`naturkartanReceive`, (e) => {
        if (e.detail.method == `loaded` && onLoad) onLoad(e.detail.data)

        if (e.detail.method == `setQuery` && onQueryChange)
          onQueryChange(e.detail.data)
      })
    }
  }, [])

  const siteLinks = useMemo(() => {
    const links = {}
    data.sites.nodes.forEach((s) => (links[s.id] = process.env.URL + s.path))
    return links
  }, [data.sites.nodes])

  if (!query) return null

  if (process.env.GATSBY_BRANDSITES_INCLUDE_UNPUBLISHED) {
    query = queryString.parse(query)
    query.published = [1, 0]
    query = queryString.stringify(query)
  }

  const attrs = {
    "data-naturkartan-disable-autoload": disableAutoload,
    "data-naturkartan-strict": true,
    "data-naturkartan-client": `satellite`,
    "data-naturkartan-language": language || data.site.siteMetadata.lang,
    "data-naturkartan-site-links": JSON.stringify(siteLinks),
    "data-naturkartan-category-names": JSON.stringify(categoryNames),
    "data-naturkartan-query": query,
    "data-naturkartan-preselected-site-id": preselectedSiteId,
    "data-naturkartan-quick-categories": quickCategories,
    "data-naturkartan-menu": menu,
    "data-naturkartan-menu-sort": menuSort,
    "data-naturkartan-style": style,
    "data-naturkartan-zoom": zoom,
    "data-naturkartan-style-control": styleControl,
    "data-naturkartan-zoom-control": zoomControl,
    "data-naturkartan-measure-control": measureControl,
    "data-naturkartan-location-control": locationControl,
    "data-naturkartan-print-control": printControl,
    "data-naturkartan-legend-control": legendControl,
    "data-naturkartan-legend": legend,
    "data-naturkartan-scroll-zoom": scrollZoom,
    "data-naturkartan-importance-control": false,
    "data-naturkartan-a11y-control": false,
  }

  return (
    <Container>
      <div
        style={{ width: `100%`, height: `100%`, backgroundColor: `#f5f5f2` }}
        ref={mapRef}
        {...attrs} // TODO: remove empty pairs
      />
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`
